/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Slider from 'react-slick';
import {Loader} from '../../Helpers/Helpers';

export default class FrameItems extends Component {

	selectFrame = (frameProduct) => {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedFrame: frameProduct,
				frameLoading: false
			}
		})
	};

	render() {
		const {frameProducts, displayCategory, selectedFrame, slidesToShow, viewportWidth} = this.props;
		let slidedShow = slidesToShow;
		if (viewportWidth < 576) {
			slidedShow = 3
		}
		if (viewportWidth < 361) {
			slidedShow = 2
		}
		var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: slidedShow,
            slidesToScroll: slidedShow,
            lazyLoad: true,
            pauseOnHover: true
        };
	    return (
	    	<div className="frm_mn_box">
	            {this.props.productsLaoded ?
	            	<Slider ref={c => this.slider = c} {...settings}>
	                	{frameProducts.filter( ( frameProduct ) =>
	                        frameProduct.get('categories').some( ( categories ) =>
	                            displayCategory === categories.get('id')
	                        )).map( (frameProduct) =>
	                			<div key={frameProduct.get('id')}>
			                        <div className="frm_box">
			                            <a href="#!" onClick={this.selectFrame.bind(this, frameProduct)}>
											<i className={selectedFrame.get('id') === frameProduct.get('id') ? "selectedImageFrame" : '' }>
												<img src={frameProduct.getIn(['images', 0, 'src'])} alt={frameProduct.get('name')} />
											</i>
			                            </a>
			                            <p>
			                            	<a href="#!" className="link" onClick={this.selectFrame.bind(this, frameProduct)}>{frameProduct.get('name')}</a>
			                            </p>
			                        </div>
		                        </div>
	                		)
	                	}
	                </Slider>
    		 	: <Loader/>
    			}
		    </div>
	    );
	}
}